import { memo } from "react";

import type { SidebarThreadStatus } from "./Sidebar.logic";
import { AvatarLabAvatar, type AvatarLabAnimation } from "./CloudeeAvatar";

export type ThreadAvatarState = SidebarThreadStatus | "done" | "woke";

const STATE_ANIMATION: Record<ThreadAvatarState, AvatarLabAnimation> = {
  approval: "surprised",
  done: "celebrate",
  failed: "sad",
  input: "listening",
  monitoring: "searching",
  ready: "idle",
  woke: "waking",
  working: "working",
};

export function resolveThreadAvatarAnimation(state: ThreadAvatarState): AvatarLabAnimation {
  return STATE_ANIMATION[state];
}

export const ThreadBlobatar = memo(function ThreadBlobatar({
  className,
  name,
  size,
  state = "ready",
  animated = false,
}: {
  className?: string;
  name: string;
  size: number;
  state?: ThreadAvatarState;
  animated?: boolean;
}) {
  return (
    <AvatarLabAvatar
      seed={name}
      size={size}
      animation={resolveThreadAvatarAnimation(state)}
      animated={animated}
      ariaHidden
      {...(className === undefined ? {} : { className })}
    />
  );
});
